import { EventEmitter } from "events";
import { LogEventNames } from "../../../backend/interfaces/ITelemetryLogger";
import { HostAppName } from "../../../backend/office-js/HostAppSettings";
import { HostAppUtil } from "../../../backend/office-js/HostAppUtil";
import oneNoteTranscriptionManager, { NavigateToAssociatedPage, OneNoteManagerActionTypes } from "../../../backend/OneNote/OneNoteTranscriptionManager";
import { LogError } from "../../../utils/ErrorTelemetry";
import { ErrorStringFromException } from "../../../utils/utils";
import dispatcher from "../../dispatcher";
import { ChangeEvent } from "../../stores/utils";
import { ExtendedInfo, HostAppInfoBarState } from "./HostAppInfoBar";

export class HostAppInfoBarManager extends EventEmitter {

    private state: HostAppInfoBarState;

    constructor() {
        super();
        this.state = this.getInitialState();
        dispatcher.register(this.handleUpdate);
    }

    public getState = (): HostAppInfoBarState => {
        return Object.assign({}, this.state);
    }

    public handleUpdate = (action: Event): void => {
        switch (action.type) {
            case OneNoteManagerActionTypes.OneNoteAssociatedPageUpdate:
                this.state.secondaryTitle = oneNoteTranscriptionManager.GetAssociatedPageName();
                this.state.extendedInfoList.length = 0;
                this.state.extendedInfoList.push({ keyString: TranscriptionStrings.NotebookTitle, valueString: oneNoteTranscriptionManager.GetAssociatedNoteBookName() });
                this.state.extendedInfoList.push({ keyString: TranscriptionStrings.SectionTitle, valueString: oneNoteTranscriptionManager.GetAssociatedSectionName() });
                this.state.extendedInfoList.push({ keyString: TranscriptionStrings.PageTitle, valueString: oneNoteTranscriptionManager.GetAssociatedPageName() });
                this.emit(ChangeEvent.Change);
                break;
        }
    }

    private getInitialState = (): HostAppInfoBarState => {
        switch (HostAppUtil.GetHostAppName()) {
            case HostAppName.ONENOTE:

                let extendedInfoList = new Array<ExtendedInfo>();
                extendedInfoList.push({ keyString: TranscriptionStrings.NotebookTitle, valueString: oneNoteTranscriptionManager.GetAssociatedNoteBookName() });
                extendedInfoList.push({ keyString: TranscriptionStrings.SectionTitle, valueString: oneNoteTranscriptionManager.GetAssociatedSectionName() });
                extendedInfoList.push({ keyString: TranscriptionStrings.PageTitle, valueString: oneNoteTranscriptionManager.GetAssociatedPageName() });

                const defaultState: HostAppInfoBarState = {
                    showHoverWindow: false,
                    primaryTitle: TranscriptionStrings.OneNotePageInfoBarDescription,
                    secondaryTitle: oneNoteTranscriptionManager.GetAssociatedPageName(),
                    extendedInfoList: extendedInfoList
                };
                return Object.assign({}, defaultState);
            default:
                return Object.assign({}, this.state);
        }
    }

    public handleOnClick = () => {
        switch (HostAppUtil.GetHostAppName()) {
            case HostAppName.ONENOTE:
                NavigateToAssociatedPage().catch((e) => {
                    LogError(LogEventNames.NavigateToLinkedOneNotePage, "Navigate to Linked page failed with error " + ErrorStringFromException(e));
                });
                break;
            default:
                break;
        }
    }

    public handleOnHover = () => {

        // if no elements provided in extendedInfoList, OnHover will not work.
        if (this.state.extendedInfoList.length <= 0) {
            return;
        }
        switch (HostAppUtil.GetHostAppName()) {
            case HostAppName.ONENOTE:

                // Page info refresh request to make sure latest info is shown to user on UI render or re-Render.
                oneNoteTranscriptionManager.RefreshPageInfoRequest().catch((e) => {
                    LogError(LogEventNames.LoadLinkedOneNotePageInfo, "Linked page info load failed with error " + ErrorStringFromException(e));
                  });
                break;
            default:
                break;
        }

        //update shohHoverWindow state to true to present extended Bar View to user.
        this.state.showHoverWindow = true;
        this.emit(ChangeEvent.Change);
    }

    public handleOnHoverDone = () => {
        this.state.showHoverWindow = false;
        this.emit(ChangeEvent.Change);
    }
}


